import { action } from 'typesafe-actions';
import { CONTAINER_TYPES } from './types';

export const getContainerData = (data: any) =>
  action(CONTAINER_TYPES.GET_CONTAINER_DATA, data);
